import { GET, POST, PUT, DELETE } from "../utils/restUtils";
import { Auth } from "aws-amplify";
import _ from "lodash";

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};

export const getDashboardReports = async config => {
  let token = await getToken();
  config = _.assign(
    {},
    {
      headers: {
        Authorization: token
      }
    },
    config
  );
  return await GET("/reports", config);
};

export const getOngoingShootReports = async config => {
  let token = await getToken();
  config = _.assign(
    {},
    {
      headers: {
        Authorization: token
      }
    },
    config
  );
  return await GET("/reports/shoot/ongoing", config);
};

export const getCompletedShootReports = async config => {
  let token = await getToken();
  config = _.assign(
    {},
    {
      headers: {
        Authorization: token
      }
    },
    config
  );
  return await GET("/reports/shoot/completed", config);
};

export const getScheduledShootReports = async config => {
  let token = await getToken();
  config = _.assign(
    {},
    {
      headers: {
        Authorization: token
      }
    },
    config
  );
  return await GET("/reports/shoot/scheduled", config);
};

export default {
  getDashboardReports,
  getOngoingShootReports,
  getCompletedShootReports,
  getScheduledShootReports
};
